module.exports = __webpack_public_path__ + "static/media/Calibre-LightItalic.3ede1be7.ttf";